
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinnavimumbai() {



    const cardData =
    {
        keyword: 'Cab Service in Navi Mumbai',
        heading: 'S9 Travels: Cab Service in Navi Mumbai',
        headingDescription: 'S9 Travels offers Cab Service in Navi Mumbai, providing a reliable, comfortable, and hassle-free travel experience for local and outstation trips. Whether you need a cab for airport transfers, corporate travel, family outings, or weekend getaways, our well-maintained fleet, including sedans, SUVs, and Innova Crysta, ensures a smooth journey. Enjoy on-time pickups, professional drivers, affordable pricing, and 24/7 service for a seamless travel experience. Book your Cab Service in Navi Mumbai with S9 Travels for a stress-free and comfortable ride!',


        top: 'Top Places to Visit in Mumbai with S9 Travels',

"topPlaces": [
    {
      "title": "Gateway of India",
      "description": "Standing tall along the Mumbai harbor, the Gateway of India is an iconic monument built in 1924 to commemorate the visit of King George V and Queen Mary. This Indo-Saracenic architectural marvel is a popular gathering spot for tourists, offering breathtaking views of the Arabian Sea. Visitors can take ferry rides to Elephanta Caves or simply enjoy the bustling atmosphere around this historic site."
    },
    {
      "title": "Marine Drive",
      "description": "Also known as the 'Queen’s Necklace' because of the way its streetlights shine like a string of pearls at night, Marine Drive is a 3.6 km-long promenade along the Arabian Sea. It is a favorite destination for both locals and tourists who come to relax, jog, or enjoy the mesmerizing sunset views. Nearby, Girgaon Chowpatty is famous for its street food, including bhel puri, pav bhaji, and kulfi."
    },
    {
      "title": "Elephanta Caves",
      "description": "A UNESCO World Heritage Site, the Elephanta Caves are located on Elephanta Island, accessible via a ferry from the Gateway of India. These ancient rock-cut caves date back to the 5th–7th century and house magnificent sculptures of Lord Shiva, including the famous three-headed Maheshmurti. The caves offer an insightful journey into India’s rich heritage and artistry."
    },
    {
      "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
      "description": "A masterpiece of Victorian Gothic architecture, CSMT is one of Mumbai’s busiest railway stations and a UNESCO World Heritage Site. Built in 1887, its intricate carvings, domes, turrets, and stained-glass windows make it an architectural marvel. The station remains a vital transportation hub while standing as a symbol of Mumbai’s colonial history."
    },
    {
      "title": "Siddhivinayak Temple",
      "description": "One of Mumbai’s most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha. Built in 1801, the temple attracts thousands of devotees daily, including Bollywood celebrities and politicians. The temple's inner sanctum houses a beautiful black stone idol of Lord Ganesha, and its gold-plated domes add to its grandeur."
    },
    {
      "title": "Haji Ali Dargah",
      "description": "Situated on an islet in the Arabian Sea, Haji Ali Dargah is an architectural marvel and a major pilgrimage site. The Indo-Islamic shrine, built in honor of the Sufi saint Pir Haji Ali Shah Bukhari, can be accessed via a narrow causeway during low tide. The site offers a spiritual experience along with stunning sea views."
    },
    {
      "title": "Juhu Beach",
      "description": "One of Mumbai’s most famous beaches, Juhu Beach is known for its lively atmosphere, local street food, and stunning sunset views. It’s a popular destination for tourists, fitness enthusiasts, and food lovers, with stalls serving Mumbai’s famous chaats like sev puri, vada pav, and pani puri. Many Bollywood celebrities reside nearby, making it a celebrity-spotting hotspot."
    },
    {
      "title": "Colaba Causeway",
      "description": "A paradise for shopaholics, Colaba Causeway is a bustling street market offering a mix of trendy clothes, jewelry, souvenirs, and antiques at bargain prices. The area is also home to famous cafes like Leopold Café and Café Mondegar, making it a great spot to experience Mumbai’s vibrant street life and café culture."
    },
    {
      "title": "Bandra-Worli Sea Link",
      "description": "A symbol of modern Mumbai, the Bandra-Worli Sea Link is an engineering marvel that connects South Mumbai to its western suburbs. This cable-stayed bridge offers breathtaking views of the city skyline, especially at night when it is beautifully illuminated. A drive across this bridge is a must for every visitor."
    },
    {
      "title": "Sanjay Gandhi National Park & Kanheri Caves",
      "description": "Located in the heart of Mumbai, Sanjay Gandhi National Park is one of the world’s few national parks within a metropolis. It offers lush greenery, wildlife sightings, and adventure activities like trekking and cycling. Within the park lie the ancient Kanheri Caves, Buddhist rock-cut caves dating back to the 1st century BCE, featuring intricate carvings and stupas."
    }
],

"services": [
  {
    "name": "Cab Service in Navi Mumbai",
    "description": "S9 Travels provides reliable and comfortable cab services in Navi Mumbai. Whether you're heading for business, leisure, or a special occasion, our well-maintained cabs and experienced drivers ensure a smooth and pleasant journey across the city."
  },
  {
    "name": "Book Taxis in Navi Mumbai",
    "description": "Booking a taxi in Navi Mumbai with S9 Travels is simple and hassle-free. We offer a range of vehicles to suit your needs, from compact cabs to luxury options, for both local travel and outstation trips. Book your taxi easily and enjoy a safe and comfortable ride."
  },
  {
    "name": "Affordable Cab Service in Navi Mumbai",
    "description": "S9 Travels offers affordable cab services in Navi Mumbai without compromising on comfort or reliability. Whether you're on a budget or need a cost-effective travel option, we provide high-quality service at competitive prices for all your transportation needs."
  },
  {
    "name": "Navi Mumbai Private Car Hire",
    "description": "For a more personalized travel experience, opt for private car hire in Navi Mumbai with S9 Travels. Enjoy the comfort and privacy of a dedicated vehicle and driver, whether you're attending a business meeting, exploring the city, or going to an event."
  },
  {
    "name": "Luxury Cab Service in Navi Mumbai",
    "description": "Experience premium travel with S9 Travels' luxury cab service in Navi Mumbai. Our fleet of luxury vehicles provides top-notch comfort, modern amenities, and professional chauffeurs, ensuring a stylish and comfortable ride for business or leisure trips."
  },
  {
    "name": "Navi Mumbai Local and Outstation Cabs",
    "description": "S9 Travels offers both local and outstation cab services in Navi Mumbai. Whether you're traveling within the city for errands or exploring nearby destinations, we have flexible options that suit your schedule and preferences."
  },
  {
    "name": "Navi Mumbai Airport Taxi Service",
    "description": "Travel to and from Navi Mumbai Airport with ease using S9 Travels' airport taxi service. Our professional drivers ensure timely pickups and drops, providing you with a stress-free and comfortable ride to or from the airport."
  },
  {
    "name": "Taxi for Sightseeing in Navi Mumbai",
    "description": "Explore the attractions of Navi Mumbai with a dedicated sightseeing taxi from S9 Travels. Our experienced drivers will guide you through the city's most famous landmarks, ensuring a fun and informative journey while you enjoy the sights in comfort."
  },
  {
    "name": "Book Cabs for Navi Mumbai Travel",
    "description": "Booking a cab for your Navi Mumbai travel is simple with S9 Travels. Whether you're going for a meeting, sightseeing, or an outstation trip, we offer reliable and convenient taxi services to make your journey comfortable and enjoyable."
  }
],

"tableData": [
  ["Cab Service in Navi Mumbai", "Book Taxis in Navi Mumbai"],
  ["Affordable Cab Service in Navi Mumbai", "Navi Mumbai Private Car Hire"],
  ["Luxury Cab Service in Navi Mumbai", "Navi Mumbai Local and Outstation Cabs"],
  ["Navi Mumbai Airport Taxi Service", "Taxi for Sightseeing in Navi Mumbai"],
  ["Book Cabs for Navi Mumbai Travel", ""],
  ["", ""]
],





"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Convenient Travel",
    "WhyChoosedescription": "S9 Travels offers reliable cab services in Navi Mumbai, providing a comfortable and convenient travel experience. Our well-maintained vehicles, including sedans, SUVs, and luxury cars, ensure a smooth ride, whether you're commuting for work, leisure, or special events."
  },
  {
    "WhyChooseheading": "Timely and Dependable Service",
    "WhyChoosedescription": "We understand the importance of timely travel. Our cab service in Navi Mumbai ensures punctual pick-ups and drop-offs, so you can rely on us to get you to your destination on time, whether it's for business, an event, or personal errands."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are professional, experienced, and familiar with the best routes in Navi Mumbai. They prioritize your comfort and safety, ensuring that you enjoy a smooth and secure journey throughout your ride, no matter where you're headed."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable rates for cab services in Navi Mumbai, with a transparent pricing structure. We ensure no hidden charges, providing a clear breakdown of the fare during booking, so you can plan your budget without any surprises."
  },
  {
    "WhyChooseheading": "Safety and Comfort for Every Ride",
    "WhyChoosedescription": "Your safety is our top priority. Our vehicles are equipped with modern safety features such as GPS tracking, airbags, and seat belts, ensuring a safe and comfortable ride for you and your passengers throughout your journey in Navi Mumbai."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Scheduling",
    "WhyChoosedescription": "S9 Travels operates 24/7, offering flexible scheduling for your cab service needs in Navi Mumbai. Whether you need an early morning ride, a late-night return, or a ride at any time of the day, we are here to accommodate your schedule."
  },
  {
    "WhyChooseheading": "Customizable Routes and Stops",
    "WhyChoosedescription": "We understand that every trip is unique. Whether you need multiple stops, detours, or specific locations to visit, we offer customizable routes to make your journey in Navi Mumbai more convenient and tailored to your needs."
  },
  {
    "WhyChooseheading": "Simple and Hassle-Free Booking",
    "WhyChoosedescription": "Booking your cab service in Navi Mumbai with S9 Travels is quick and easy. You can book your ride online via our website or mobile app, or reach out to our customer service team for personalized assistance, ensuring a smooth booking process."
  }
]













    }

    const faqData = [
        [
          {
            question: 'How can I book a cab service in Navi Mumbai?',
            answer: 'Booking a cab service in Navi Mumbai is easy! You can book a ride via our website, mobile app, or by contacting our customer service team. We ensure a hassle-free and comfortable journey for all your travel needs.',
          },
          {
            question: 'What types of cabs are available for hire in Navi Mumbai?',
            answer: 'We offer a variety of cabs in Navi Mumbai, including sedans, SUVs, luxury vehicles like the Toyota Innova, and more. Choose the vehicle that best suits your travel preferences and group size.',
          },
          {
            question: 'Are the drivers experienced in Navi Mumbai?',
            answer: 'Yes, all our drivers are highly experienced and familiar with the routes in Navi Mumbai. They ensure a smooth, safe, and comfortable ride, whether it’s a local trip or a long-distance journey.',
          },
          {
            question: 'Do you offer both local and outstation cab services in Navi Mumbai?',
            answer: 'Yes, we offer both local and outstation cab services in Navi Mumbai. Whether you need a ride within the city or an outstation trip, we have well-maintained vehicles and professional drivers to meet your requirements.',
          },
          {
            question: 'Can I book a cab for airport transfers in Navi Mumbai?',
            answer: 'Yes, we provide convenient and reliable airport transfer services to and from Navi Mumbai. Our drivers will ensure you reach your destination on time, offering a stress-free experience.',
          },
          {
            question: 'Is there a fixed fare for cab services in Navi Mumbai?',
            answer: 'The fare for cab services in Navi Mumbai depends on the distance, type of vehicle, and the specific requirements of your trip. Contact us for a personalized quote, and we’ll provide transparent pricing.',
          },
          {
            question: 'Can I book a cab in advance for a trip in Navi Mumbai?',
            answer: 'Yes, you can book a cab in advance for your trip in Navi Mumbai. We recommend booking at least 1-2 days in advance to ensure vehicle availability, but we also accommodate last-minute bookings depending on availability.',
          },
          {
            question: 'Can I request additional services during my cab ride in Navi Mumbai?',
            answer: 'Yes, we can arrange for additional services like sightseeing, meals, or additional stops during your ride in Navi Mumbai. Simply let us know your preferences, and we’ll customize your journey.',
          },
          {
            question: 'Why should I choose S9 Travels for my cab service in Navi Mumbai?',
            answer: 'S9 Travels offers reliable, safe, and comfortable cab services in Navi Mumbai. With professional drivers, well-maintained vehicles, and excellent customer service, we ensure a smooth and enjoyable experience for every ride.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Raghav Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I used S9 Travels for a cab service in Navi Mumbai, and I was extremely impressed. The booking process was smooth, the driver was punctual and professional, and the car was clean and well-maintained. I highly recommend their services for anyone in Navi Mumbai!”',
        },
        {
          name: 'Mrs. Shweta Kapoor',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“We hired a cab from S9 Travels for a family trip in Navi Mumbai, and the experience was fantastic. The driver was friendly and knowledgeable, and the ride was comfortable and stress-free. We will definitely use their services again for future trips.”',
        },
      ];
      
      
      
      
      
    
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

      
     
      
      
      


    return (
        <div>
        

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/82.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinnavimumbai;